import { cssVar, storeFactory } from 'ovpn-ui-toolkit';

const NOTIFICATIONS_KEY = 'notifications';

export const { set: setNotification, get: getNotification } = storeFactory(
    NOTIFICATIONS_KEY,
    '@ovpn',
);

const NOTIFICATION_OFFSET_CSS_VAR = '--notification-top-offset';

export function setTopOffset(offset: number) {
    cssVar.setNumber(NOTIFICATION_OFFSET_CSS_VAR, offset);
}

export function getTopOffset(): number {
    const offset = cssVar.getNumber(NOTIFICATION_OFFSET_CSS_VAR);
    return Number.isNaN(offset) ? 0 : offset;
}

// convert a Unicode string to a string in which
// each 16-bit unit occupies only one byte
function toBinary(str: string) {
    const codeUnits = Uint16Array.from({ length: str.length }, (_, index) => str.charCodeAt(index));
    const charCodes = new Uint8Array(codeUnits.buffer);

    let result = '';
    for (const char of charCodes) {
        result += String.fromCharCode(char);
    }

    return result;
}

export function decodeBase64(data: string) {
    const converted = toBinary(data);
    const encoded = btoa(converted);
    return encoded;
}
